import { render, staticRenderFns } from "./CloseRequestPasswordComponent.vue?vue&type=template&id=2085ba7e&scoped=true&"
import script from "./CloseRequestPasswordComponent.vue?vue&type=script&lang=js&"
export * from "./CloseRequestPasswordComponent.vue?vue&type=script&lang=js&"
import style0 from "./CloseRequestPasswordComponent.vue?vue&type=style&index=0&id=2085ba7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2085ba7e",
  null
  
)

export default component.exports